export default __webpack_public_path__ + "static/media/teamwork_active.e2fda55f.svg";